<template>
    <!-- Общий popup входа -->
    <div v-if="shell && (shell.showCommonLoginPopup || state.showCommonLoginPopup)" class="popup popup--auth-choice" v-popup-tall>
      <div class="popup__overlay" @click="shell.closeCommonLoginPopup()"></div>
      <div class="popup__window">
        <button @click="shell.closeCommonLoginPopup()" class="modal-close"></button>
        <div class="modal-content">
          <h5 class="modal-title">Требуется авторизация</h5>
          <div class="group-common-buttons">
            <span>У меня уже есть аккаунт</span>
            <button class="button button-red" type="button" @click="shell.openLoginPopup()">Войти</button>
          </div>
          <div class="group-common-buttons">
            <span>У меня нет аккаунта</span>
            <button
              class="button button-red button-red--inverse"
              type="button"
              :title="shell.isPromoClosedForRegistration() ? 'Регистрация недоступна — акция завершена. Нажмите, чтобы открыть сообщение.' : undefined"
              @click="shell.openRegisterPopup()"
            >Регистрация</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Задать вопрос -->
    <div v-if="shell && shell.showQuestionPopup" class="popup popup--question" v-popup-tall>
      <div class="popup__overlay" @click="shell.closeQuestionPopup()"></div>
      <div class="popup__window">
        <button @click="shell.closeQuestionPopup()" class="modal-close"></button>
        <div class="modal-content">
          <h5 class="modal-title">Обратная связь</h5>
          <form @submit.prevent="shell.submitQuestion" autocomplete="off" class="form form--feedback">
            <div class="field-row" data-cols="1">
              <div class="field-item field-item--floating" data-label="Имя">
                <label for="feedback-name">Имя</label>
                <input
                    type="text"
                    class="form__input"
                    v-model="shell.questionForm.name"
                    id="feedback-name"
                    name="name"
                    @blur="shell.validateField('name')"
                    @input="(shell.removeSpacesName(), shell.validateField('name'))"
                    placeholder="Иван"/>
                <span v-if="shell.feedbackErrors.name" class="error-message">{{ shell.feedbackErrors.name }}</span>
              </div>
            </div>
            <div class="field-row" data-cols="1">
              <div class="field-item field-item--floating" data-label="Email">
                <label for="feedback-email">Email</label>
                <input
                    type="email"
                    class="form__input"
                    v-model="shell.questionForm.email"
                    id="feedback-email"
                    name="email"
                    @blur="shell.validateField('email_feedback')"
                    @input="shell.validateField('email_feedback')"
                    placeholder="ХХХ@ХХХ.ХХ"/>
                <span v-if="shell.feedbackErrors.email" class="error-message">{{ shell.feedbackErrors.email }}</span>
              </div>
            </div>
            <div class="field-row" data-cols="1">
              <div class="field-item field-item--feedback-topic">
                <label for="feedback-topic-dropdown">Тема обращения</label>
                <div
                  class="dropdown dropdown--feedback-topic"
                  :class="{ 'dropdown--feedback-topic-open': shell.isOpen }"
                  data-feedback-dropdown
                >
                  <button
                    id="feedback-topic-dropdown"
                    type="button"
                    :class="['dropdown__button', 'dropdown__button--feedback-topic', { active: shell.isChange, 'is-error': shell.feedbackErrors.subject }]"
                    data-feedback-dropdown-btn
                    :aria-expanded="shell.isOpen ? 'true' : 'false'"
                    aria-haspopup="listbox"
                    @click="shell.toggleDropdown()"
                    @blur="shell.validateField('subject')"
                  >
                    <span
                      class="dropdown__button-text"
                      :class="{ 'dropdown__button-text--placeholder': !shell.isChange }"
                    >{{ shell.selectedText }}</span>
                  </button>
                  <div
                    class="dropdown__list dropdown__list--feedback-topic"
                    data-feedback-dropdown-list
                    :class="{ 'dropdown__list--visible': shell.isOpen }"
                  >
                    <ul class="dropdown__list-scroll list-scrollbar" role="listbox">
                      <li
                        v-for="item in shell.topics"
                        :key="item.id"
                        class="dropdown__list-item"
                        role="option"
                        @click="shell.selectItem(item)"
                        :data-value="item.id"
                      >
                        {{ item.title }}
                      </li>
                    </ul>
                  </div>
                  <input type="text" name="subject" class="dropdown__input-hidden" v-model="shell.questionForm.subject" tabindex="-1" aria-hidden="true">
                  <span v-if="shell.feedbackErrors.subject" class="error-message">{{ shell.feedbackErrors.subject }}</span>
                </div>
              </div>
            </div>
            <div class="field-row" data-cols="1">
              <div class="field-item field-item--floating" data-label="Сообщение">
                <label for="feedback-message">Сообщение</label>
                    <textarea v-autogrow-textarea
                              id="feedback-message"
                              @focus="shell.isFocus = !shell.isFocus"
                              @input="shell.clearFeedbackError('text')"
                              v-model="shell.questionForm.text"
                              class="form__input --message"
                              name="text"
                              maxlength="600"
                              @blur="shell.validateField('text')"
                              placeholder="Сообщение"></textarea>
                <div class="form__char-counter">
                  <span>{{ shell.questionForm.text ? shell.questionForm.text.length : 0 }}/600</span>
                </div>
                <span v-if="shell.feedbackErrors.text" class="error-message">{{ shell.feedbackErrors.text }}</span>
              </div>
            </div>
            <div class="field-row" data-cols="1">
              <div class="field-item">
                <div class="file">
                  <template v-if="shell.filePreviews.length < 10">
                    <label class="file">
                      <input
                          type="file"
                          id="feedback-files"
                          name="files"
                          multiple
                          class="file__real"
                          @change="shell.handleFileChange"
                          accept=".jpg, .jpeg, .png, .gif, .tiff, .webp, .pdf">
                      <div class="file__custom">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M13.3327 7.66703L8.28973 12.4232C7.67193 13.0058 6.83401 13.3332 5.96031 13.3332C5.08661 13.3332 4.24869 13.0058 3.63089 12.4232C3.01309 11.8405 2.66602 11.0502 2.66602 10.2262C2.66602 9.40223 3.01309 8.61197 3.63089 8.02931L8.67385 3.27317C9.08571 2.88473 9.64432 2.6665 10.2268 2.6665C10.8093 2.6665 11.3679 2.88473 11.7797 3.27317C12.1916 3.66161 12.423 4.18845 12.423 4.73779C12.423 5.28713 12.1916 5.81397 11.7797 6.20241L6.73129 10.9586C6.52536 11.1528 6.24606 11.2619 5.95482 11.2619C5.66359 11.2619 5.38428 11.1528 5.17835 10.9586C4.97242 10.7643 4.85672 10.5009 4.85672 10.2262C4.85672 9.95157 4.97242 9.68815 5.17835 9.49393L9.83718 5.10524" stroke="#01146C" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>

                        <span class="file__text">Прикрепить файл</span>
                      </div>
                    </label>
                  </template>
                  <p v-else class="file__text file__text--max">Прикреплено максимальное количество файлов</p>
                  <div class="file-info">
                    <p>Разрешенные форматы файлов: .jpg, .jpeg, .png, .gif, .tiff, .webp, .pdf.</p>
                    <p>Максимальный размер файла: 5МВ.</p>
                    <p>Максимальное количество файлов: 10.</p>
                  </div>
                  <ul class="form__checks" v-if="shell.filePreviews.length">
                    <li class="form__check" v-for="(file, index) in shell.filePreviews" :key="index">
                      <button @click="shell.removeFile(index)" class="form__check-close" type="button"></button>
                      <img loading="lazy" v-if="file.type.startsWith('image')" :src="file.preview" :alt="file.name" class='full-img' width='100' height='100' />
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="field-row" data-cols="1">
              <div class="field-item field-item-checkbox">
                <label>
                  <input type="checkbox" name="соглашение" class="checkbox__real-input" v-model="shell.questionForm.agree_personal_data" @input="shell.clearFeedbackError('agree_personal_data')">
                  <span>Согласен(на) с обработкой <a :href="shell.agreementUrl" target="_blank" rel="noopener noreferrer">персональных данных</a></span>
                </label>
                <span v-if="shell.feedbackErrors.agree_personal_data" class="error-message">{{ shell.feedbackErrors.agree_personal_data }}</span>
              </div>
              <div class="field-item field-item-checkbox">
                <label>
                  <input type="checkbox" class="checkbox__real-input" v-model="shell.questionForm.agree_to_advertising">
                  <span>Даю <a :href="shell.advertisingUrl" target="_blank" rel="noopener noreferrer">согласие</a> на получение информационной и рекламной рассылки</span>
                </label>
              </div>
            </div>
            <div class="field-row-action field-row-action--feedback-submit">
              <button type="submit" class="button button-red"
                      :class="{'button-loader': shell.formSending}"
                      :disabled="!shell.isQuestionFormValid || shell.formSending">ОТПРАВИТЬ</button>
              <div class="error-message error-message--response" v-if="shell.responseError">{{ popupErrorMessage(shell.responseError) }}</div>
            </div>
          </form>

        </div>
      </div>
    </div>

    <!-- Popup для входа -->
    <div v-if="shell && shell.showLoginPopup" class="popup popup--login" v-popup-tall>
      <div class="popup__overlay" @click="shell.closeLoginPopup()"></div>
      <div class="popup__window">
        <button @click="shell.closeLoginPopup()" class="modal-close">
        </button>
        <div class="modal-content">
          <h5 class="modal-title">Авторизация</h5>
          <form class="form" @submit.prevent="shell.login" autocomplete="off">
            <div class="field-row" data-cols="1">
              <div class="field-item field-item--floating" data-label="Логин">
                <label for="popup-login-email">Email</label>
                <input
                  class="form__input"
                  type="email"
                  id="popup-login-email"
                  name="email"
                  v-model="shell.email"
                  placeholder="ХХХ@ХХХ.ХХ"
                  @blur="shell.validateLoginEmail"
                  @input="shell.validateLoginEmail"
                  required
                >
                <span v-if="shell.loginFormErrors.email" class="error-message">{{ shell.loginFormErrors.email }}</span>
              </div>
            </div>
            <div class="field-row" data-cols="1">
              <div class="field-item field-item--floating" data-label="Пароль">
                <label for="popup-login-password">Пароль</label>
                <PasswordFieldEyeToggle
                  :revealed="shell.passwordVisible"
                  @toggle="shell.togglePasswordVisibility"
                />
                <input
                  class="form__input"
                  id="popup-login-password"
                  :type="shell.passwordVisible ? 'text' : 'password'"
                  maxlength="255"
                  name="password"
                  v-model="shell.password"
                  placeholder="Введите пароль"
                  @keydown.space.prevent
                  @blur="shell.validateLoginPassword"
                  @input="shell.validateLoginPassword"
                  required
                >
                <span v-if="shell.loginFormErrors.password" class="error-message">{{ shell.loginFormErrors.password }}</span>
                <button class="form__text-btn --forget" type="button" @click="shell.openResetPasswordPopup()">Забыли пароль?</button>
              </div>
            </div>
            <div class="field-row-action">
              <button class="button button-red"
                      :class="{'button-loader': shell.formSending}"
                      :disabled="!shell.isLoginFormValid || shell.formSending"
                      type="submit">Войти</button>
              <div class="error-message error-message--response" v-if="shell.responseError">{{ popupErrorMessage(shell.responseError) }}</div>
            </div>
            <div class="field-row-additional">
              <span class="not-account">
                <span>Нет аккаунта?</span>
                <button
                  type="button"
                  class="link"
                  :title="shell.isPromoClosedForRegistration() ? 'Регистрация недоступна — акция завершена. Нажмите, чтобы открыть сообщение.' : undefined"
                  @click="shell.openRegisterPopup()"
                >Регистрация</button>
              </span>
            </div>
          </form>

        </div>
      </div>
    </div>

    <!-- Popup для регистрации -->
    <div v-if="shell && shell.showRegisterPopup" class="popup popup--register" v-popup-tall>
      <div class="popup__overlay" @click="shell.closeRegisterPopup()"></div>
      <div class="popup__window">
        <button @click="shell.closeRegisterPopup()" class="modal-close"></button>
        <div class="modal-content">
          <h5 class="modal-title">Регистрация</h5>
          <form class="form form-grid" @submit.prevent="shell.register" autocomplete="off">
            <div class="field-row" data-cols="1">
              <div class="field-item field-item--floating" data-label="Имя">
                <label for="register-first-name">Имя</label>
                <input class="form__input"
                       id="register-first-name"
                       maxlength="255"
                       v-model="shell.registerForm.first_name"
                       @input="(shell.removeSpacesFirstName(), shell.validateField('first_name'))"
                       type="text"
                       name="first_name"
                       placeholder="Иван"
                       autocomplete="off"
                       @blur="shell.validateField('first_name')"
                       :class="{ 'is-not-valid': shell.errors.first_name }">
                <span v-if="shell.errors.first_name" class="error-message">{{ shell.errors.first_name }}</span>
              </div>
            </div>
            <div class="field-row" data-cols="1">
              <div class="field-item field-item--floating" data-label="Фамилия">
                <label for="register-last-name">Фамилия</label>
                <input class="form__input"
                       id="register-last-name"
                       maxlength="255"
                       v-model="shell.registerForm.last_name"
                       @input="(shell.removeSpacesLastName(), shell.validateField('last_name'))"
                       @blur="shell.validateField('last_name')"
                       name="last_name"
                       type="text"
                       placeholder="Иванов">
                <span v-if="shell.errors.last_name" class="error-message">{{ shell.errors.last_name }}</span>
              </div>
            </div>
            <div class="field-row" data-cols="1">
              <div class="field-item field-item--floating" data-label="Email">
                <label for="register-email">Email</label>
                <input class="form__input"
                       id="register-email"
                       type="text"
                       maxlength="255"
                       v-model="shell.registerForm.email"
                       name="email"
                       autocomplete="off"
                       placeholder="ХХХ@ХХХ.ХХ"
                       @input="shell.validateField('email')"
                       @blur="shell.validateField('email')"
                       :class="{ 'is-not-valid': shell.errors.email }">
                <span v-if="shell.errors.email" class="error-message">{{ shell.errors.email }}</span>
              </div>
            </div>
            <div class="field-row" data-cols="1">
              <div class="field-item field-item--floating" data-label="Номер телефона">
                <label for="register-phone">Номер телефона</label>
                <input class="form__input"
                       id="register-phone"
                       type="text"
                       placeholder="+7 (900) 000 00 00"
                       maxlength="18"
                       v-model="shell.registerForm.phone_number"
                       name="phone_number"
                       autocomplete="off"
                       @input="shell.validateField('phone_number')"
                       @blur="shell.validateField('phone_number')"
                       :class="{ 'is-not-valid': shell.errors.phone_number }" v-mask>
                <span v-if="shell.errors.phone_number" class="error-message">{{ shell.errors.phone_number }}</span>
              </div>
            </div>
            <div class="field-row" data-cols="1">
              <div class="field-item field-item-checkbox">
                <label>
                  <input type="checkbox" class="checkbox__real-input" v-model="shell.registerForm.agree_rules" @blur="shell.clearError('agree_rules')">
                  <span>Я согласен(на) с <a :href="shell.rulesUrl" @click="shell.handleRulesButtonClick()" target="_blank" rel="noopener noreferrer">правилами акции</a></span>
                </label>
                <span v-if="shell.errors.agree_rules" class="error-message --position-static">{{ shell.errors.agree_rules }}</span>
              </div>
              <div class="field-item field-item-checkbox">
                <label>
                  <input type="checkbox" class="checkbox__real-input" v-model="shell.registerForm.is_policy" @blur="shell.clearError('is_policy')">
                  <span>Я согласен(на) на обработку моих <a :href="shell.agreementUrl" target="_blank" rel="noopener noreferrer">персональных данных</a>.</span>
                </label>
                <span v-if="shell.errors.is_policy" class="error-message --position-static">{{ shell.errors.is_policy }}</span>
              </div>
              <div class="field-item field-item-checkbox">
                <label>
                  <input type="checkbox" class="checkbox__real-input" v-model="shell.registerForm.agree_to_advertising">
                  <span>Я согласен(на) на получение персональных предложений от&nbsp;партнера</span>
                </label>
              </div>
            </div>
            <div class="field-row-action">
              <div class="error-message error-message--response" v-if="shell.responseError">{{ popupErrorMessage(shell.responseError) }}</div>
              <button class="button button-red"
                      :class="{'button-loader': shell.formSending}"
                      :disabled="!shell.isRegisterFlowAllowed() || !shell.isRegisterFormValid || shell.formSending">Регистрация</button>
            </div>
            <div class="field-row-additional">
              <div class="not-account">
                <span>Уже есть аккаунт?</span>
                <button type="button" class="link" @click="shell.switchToLogin()">Войти</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div v-if="shell && shell.showRegisterPopupSuccess" class="popup popup--register-success" v-popup-tall>
      <div class="popup__overlay" @click="shell.closeRegisterPopupSuccess()"></div>
      <div class="popup__window">
        <button @click="shell.closeRegisterPopupSuccess()" class="modal-close">
        </button>
        <div class="modal-content">
          <h5 class="modal-title">Регистрация завершена</h5>
          <p>На почту {{ shell.registrationSuccessEmail || shell.registerForm.email }} отправлен пароль.
            <br><br>Если Вы не получили письмо в течение нескольких минут, пожалуйста, проверьте папку «Спам».</p>
          <div class="modal-actions">
            <button type="button" class="button button-red" @click="shell.openLoginFromRegisterSuccess()">Войти</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Popup успешной отправки вопроса -->
    <div v-if="shell && shell.showQuestionPopupSuccess" class="popup popup--question-success" v-popup-tall>
      <div class="popup__overlay" @click="shell.closeQuestionPopupSuccess()"></div>
      <div class="popup__window">
        <button @click="shell.closeQuestionPopupSuccess()" class="modal-close"></button>
        <div class="modal-content">
          <h5 class="modal-title">Спасибо за обращение!</h5>
          <p class="modal-subtitle">
            Мы обязательно Вам ответим в течение 72 часов.
          </p>
        </div>
      </div>
    </div>

    <!-- Popup для восстановления пароля -->
    <div v-if="shell && shell.showResetPasswordPopup" class="popup popup--reset-password" v-popup-tall>
      <div class="popup__overlay" @click="shell.closeResetPasswordPopup()"></div>
      <div class="popup__window">
        <button @click="shell.closeResetPasswordPopup()" class="modal-close"></button>
        <div class="modal-content">
          <h5 class="modal-title">Восстановление пароля</h5>
          <form class="form" @submit.prevent="shell.submitResetPassword" autocomplete="off">
            <div class="field-row" data-cols="1">
              <div
                :class="['field-item', 'field-item--floating', { 'field-item--active': shell.resetPasswordForm.email }]"
                data-label="Email"
              >
                <label for="reset-password-email">Email</label>
                <input
                  type="email"
                  id="reset-password-email"
                  v-model="shell.resetPasswordForm.email"
                  name="email"
                  placeholder="ХХХ@ХХХ.ХХ"
                  class="form__input"
                  @blur="shell.validateResetPasswordEmail"
                  @input="shell.validateResetPasswordEmail"
                  :class="{ 'is-not-valid': shell.resetPasswordErrors.email }"
                >
                <span v-if="shell.resetPasswordErrors.email" class="error-message">{{ shell.resetPasswordErrors.email }}</span>
              </div>
            </div>
            <div class="field-row-action">
              <div class="error-message error-message--response" v-if="shell.responseError">{{ popupErrorMessage(shell.responseError) }}</div>
              <button class="button button-red"
                      :class="{'button-loader': shell.formSending}"
                      :disabled="!shell.isResetPasswordFormValid || shell.formSending">Восстановить</button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div v-if="shell && shell.showResetPasswordSuccess" class="popup popup--reset-password-success" v-popup-tall>
      <div class="popup__overlay" @click="shell.closeResetPasswordPopupSuccess()"></div>
      <div class="popup__window">
        <button @click="shell.closeResetPasswordPopupSuccess()" class="modal-close"></button>
        <div class="modal-content">
          <h5 class="modal-title">Восстановление пароля</h5>
          <p class="modal-subtitle">На почту {{ shell.resetPasswordEmail || shell.resetPasswordForm.email }} отправлен новый пароль.
            <br><br>Если Вы не получили письмо в течение нескольких минут, пожалуйста, проверьте папку «Спам».</p>
          <div class="field-row-action">
            <button class="button button-red" @click="shell.switchToLogin()">Войти</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Popup статусов акции (status из /api/main/settings: future / past) -->
    <div v-if="shell && shell.showPromoNotStarted" class="popup popup--promo-not-started" v-popup-tall>
      <div class="popup__overlay" @click="shell.closeShowPromoNotStarted()"></div>
      <div class="popup__window">
        <button class="modal-close" type="button" @click="shell.closeShowPromoNotStarted()"></button>
        <div class="popup__content">
          <div class="modal-title">
            Акция скоро начнётся
          </div>
          <div class="modal-subtitle">
            <p>Акция «Первое правило плова» ещё не началась.</p>
            <p>Следите за обновлениями — совсем скоро вы сможете принять участие.</p>
          </div>
        </div>
      </div>
    </div>
    <div v-if="shell && shell.showPromoEnd" class="popup popup--promo-end" v-popup-tall>
      <div class="popup__overlay" @click="shell.closeShowPromoEnd()"></div>
      <div class="popup__window">
        <button type="button" @click="shell.closeShowPromoEnd()" class="modal-close"></button>
        <div class="popup__content">
          <div class="modal-title">
            Акция завершена
          </div>
          <div class="modal-subtitle">
            <p>Спасибо за интерес к акции «Первое правило плова».</p>
            <p>Выдача призов осуществляется до 22 июля 2026 года.</p>
            <p>До встречи в новых акциях!</p>
          </div>
        </div>
      </div>
    </div>
    <div v-if="shell && shell.showSpecialPrizeEnding" class="popup popup--demo-prize-info popup--special-prize-ending" v-popup-tall>
      <div class="popup__overlay" @click="shell.closeShowSpecialPrizeEnding()"></div>
      <div class="popup__window popup__window--large">
        <button type="button" @click="shell.closeShowSpecialPrizeEnding()" class="modal-close"></button>
        <div class="modal-content modal-content--prize-info">
          <div class="demo-prize-popup-card">
            <!-- Картинку можно подставить сюда -->
            <!-- <div class="demo-prize-popup-card__image"><img loading="lazy" src="" alt="Специальный приз" /></div> -->
            <div class="demo-prize-popup-card__title">
              Количество призов ограничено
            </div>
            <div class="demo-prize-popup-card__text">
              Количество призов подходит к концу — успейте загрузить чек и успеть забрать специальный приз по правилам акции «Первое правило плова»!
            </div>
            <div class="demo-prize-popup-card__media"></div>
            <div class="demo-prize-popup-card__mini-title">
              Как получить приз?
            </div>
            <div class="demo-prize-popup-card__text">
              Условия покупки и количество товара в чеке — по правилам акции на rice.ru.
<!--              Осталось {{ mainSettings.special_price_remaining }} шт. Условия — по правилам акции на rice.ru.-->
            </div>
            <button type="button" class="demo-prize-popup-card__action demo-prize-popup-card__action--upload" @click="shell.handleSpecialPrizeUploadClick()">
              ЗАГРУЗИТЬ ЧЕК
            </button>
          </div>
        </div>
      </div>
    </div>
    <div style="position: absolute; bottom: 100%; overflow: hidden;">
      <div id="apm-widget"></div>
    </div>
</template>

<script>
import { appRootKey } from '@/injectionKeys';
import { state } from '@/store';
import { prefixPopupServerErrorMessage } from '@/api';
import PasswordFieldEyeToggle from '@/components/PasswordFieldEyeToggle.vue';

export default {
  name: 'AppShellPopups',
  components: {
    PasswordFieldEyeToggle,
  },
  inject: {
    shell: {
      from: appRootKey,
      default: null,
    },
  },
  computed: {
    state() {
      return state;
    },
  },
  methods: {
    popupErrorMessage(text) {
      return prefixPopupServerErrorMessage(text);
    },
  },
};
</script>
